import {ProcessingMode} from "./processingmode";

export class ExtraFee {
    constructor(
        public  string?: number,
        public  uniteAmount?: string,
        public  percentage?: string,
        public  type?: string,
        public  label?: string,
        public  processingMode?: ProcessingMode,
        public  quantity?: number,
        public  totalAmount?: string
    ) {}
}
